import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent, toHandlers as _toHandlers, mergeProps as _mergeProps, createVNode as _createVNode, renderSlot as _renderSlot, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f54012e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 2,
  class: "description"
}
const _hoisted_2 = {
  key: 0,
  class: "prependIcon h-100 px-2 pl-4 d-flex align-center"
}
const _hoisted_3 = ["value", "required", "type", "min", "max", "disabled", "placeholder"]
const _hoisted_4 = {
  key: 1,
  class: "appendIcon h-100 px-4 pe-4 d-flex align-center"
}
const _hoisted_5 = {
  key: 4,
  class: "error-msg"
}
const _hoisted_6 = { class: "info-msg" }

import { computed, ref, withDefaults, useAttrs, watchEffect } from 'vue';
import omit from '@/utils/omit';
import { InputType } from '@/types';
import AtomTooltipInfo from './AtomTooltipInfo.vue';



const __default__ = {
  inheritAttrs: false,
};

interface InputProps {
  isActive?: boolean;
  menuProps?: any;
  modelValue?: any;
  placeholder?: string;
  hint?: string;
  maxWidth?: string;
  alignInput?: string;
  mask?: string | string[] | any;
  list?: string;
  label?: string;
  msgError?: string;
  type?: InputType;
  maxLength?: number | string;
  minLength?: number | string;
  max?: number | string;
  min?: number | string;
  borderColor?: string;
  height?: string | number;
  filled?: boolean;
  simple?: boolean;
  selectionOnFocus?: boolean;
  noStyle?: boolean;
  prependIcon?: boolean;
  appendIcon?: boolean;
  noBgPrependIcon?: boolean;
  noBorderPrependIcon?: boolean;
  noBgAppendIcon?: boolean;
  disabled?: boolean;
  required?: boolean;
  hasError?: boolean;
  wFull?: boolean;
  borderBottom?: boolean;
  nullable?: boolean;
  trim?: boolean;
  classes?: string;
  sizeLabel?: string;
  fontWeight?: string;
  useTooltip?: boolean;
  tooltipMessage?: string;
  isDescription?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'AtomInput',
  props: {
    isActive: { type: Boolean },
    menuProps: {},
    modelValue: { default: '' },
    placeholder: { default: undefined },
    hint: {},
    maxWidth: {},
    alignInput: { default: 'left' },
    mask: { default: '' },
    list: {},
    label: {},
    msgError: {},
    type: { default: 'text' },
    maxLength: { default: 126 },
    minLength: {},
    max: {},
    min: {},
    borderColor: { default: 'gray-500' },
    height: { default: 2.25 },
    filled: { type: Boolean, default: false },
    simple: { type: Boolean },
    selectionOnFocus: { type: Boolean },
    noStyle: { type: Boolean, default: false },
    prependIcon: { type: Boolean, default: undefined },
    appendIcon: { type: Boolean, default: undefined },
    noBgPrependIcon: { type: Boolean, default: false },
    noBorderPrependIcon: { type: Boolean, default: false },
    noBgAppendIcon: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean },
    hasError: { type: Boolean },
    wFull: { type: Boolean, default: false },
    borderBottom: { type: Boolean },
    nullable: { type: Boolean },
    trim: { type: Boolean },
    classes: { default: '' },
    sizeLabel: {},
    fontWeight: {},
    useTooltip: { type: Boolean },
    tooltipMessage: {},
    isDescription: { type: Boolean }
  },
  emits: ["update:modelValue", "click", "keydown", "focus", "update:hint"],
  setup(__props: any, { emit: __emit }) {

const props = __props;


watchEffect(() => {
  if (props.modelValue) {
    console.log('mudou')
  }
})

const emit = __emit;

const attrs = useAttrs();

const input = ref<HTMLInputElement | null>(null);

const listeners = computed(() => ({
  input: emitValue,
  keydown: processValue,
  blur: (e: Event) => {
    trimIfEnabled();
    if (typeof attrs.onBlur === 'function') attrs.onBlur(e);
  },
  focus: (e: PointerEvent) => emit('focus', e),
}));

const attributes = computed(() => omit(attrs, 'class'));


const processValue = (event: KeyboardEvent) => {
  if (!event.key) return;
  emit('keydown', event);
};

const emitValue = (event: InputEvent) => {
  const value = (event.target as HTMLInputElement).value;

  if (props.nullable === true && value === '') {
    emit('update:modelValue', null);
    return;
  }

  if (props.type === 'number') {
    const parsedNumber = Number(value);

    if (parsedNumber > 0) {
      emit('update:modelValue', parsedNumber);
    } else {
      (event.target as HTMLInputElement).value = props.modelValue;
    }
  } else {
    emit('update:modelValue', value);
  }
};

const trimIfEnabled = () => {
  if (props.modelValue && props.trim && ['string', 'text'].includes(props.type))
    emit('update:modelValue', String(props.modelValue).trim());
};

function handleCLick() {
  emit('click', '');
}

return (_ctx: any,_cache: any) => {
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", {
    onClick: handleCLick,
    class: _normalizeClass(_ctx.classes)
  }, [
    (props.useTooltip)
      ? (_openBlock(), _createBlock(AtomTooltipInfo, {
          key: 0,
          text: props.tooltipMessage
        }, {
          default: _withCtx(() => [
            (props.label)
              ? (_openBlock(), _createElementBlock("label", {
                  key: 0,
                  style: _normalizeStyle({ fontSize: props.sizeLabel === 'lg' ? '18px' : '', fontWeight: props.fontWeight }),
                  class: "input_label label"
                }, _toDisplayString(props.label) + ":", 5))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["text"]))
      : (props.label)
        ? (_openBlock(), _createElementBlock("label", {
            key: 1,
            style: _normalizeStyle({ fontSize: props.sizeLabel === 'lg' ? '18px' : '', fontWeight: props.fontWeight }),
            class: "input_label label mb-3"
          }, _toDisplayString(props.label) + ":", 5))
        : _createCommentVNode("", true),
    (props.isDescription)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_textarea, _mergeProps(attributes.value, {
            placeholder: "Digite suas observações aqui",
            variant: "plain"
          }, _toHandlers(listeners.value), {
            "model-value": props.modelValue,
            rounded: "8"
          }), null, 16, ["model-value"])
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: _normalizeClass(["input-wapper d-flex", `${_ctx.hasError ? 'error' : ''}`]),
          style: _normalizeStyle({ height: _ctx.height ? _ctx.height : '40px' })
        }, [
          (_ctx.prependIcon)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _renderSlot(_ctx.$slots, "prependIcon")
              ]))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("input", _mergeProps({
            value: props.modelValue,
            ref_key: "input",
            ref: input,
            required: _ctx.required
          }, attributes.value, {
            type: _ctx.type,
            min: _ctx.min,
            max: _ctx.max,
            disabled: _ctx.disabled
          }, _toHandlers(listeners.value, true), {
            placeholder: _ctx.placeholder,
            style: { textAlign: _ctx.alignInput, padding: '0 1rem' }
          }), null, 16, _hoisted_3), [
            [_directive_maska, _ctx.mask]
          ]),
          (_ctx.appendIcon)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _renderSlot(_ctx.$slots, "appendIcon")
              ]))
            : _createCommentVNode("", true)
        ], 6)),
    (_ctx.hasError && _ctx.msgError)
      ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(_ctx.msgError), 1))
      : _createCommentVNode("", true),
    _createElementVNode("small", _hoisted_6, _toDisplayString(_ctx.hint), 1)
  ], 2))
}
}

})